import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import bg_BG from "./locales/bg_BG/common.json"
import de_CH from "./locales/de_CH/common.json"
import es_ES from "./locales/es_ES/common.json"
import et_EE from "./locales/et_EE/common.json"
import fr_CA from "./locales/fr_CA/common.json"
import hr_HR from "./locales/hr_HR/common.json"
import it_IT from "./locales/it_IT/common.json"
import lv_LV from "./locales/lv_LV/common.json"
import nb_NO from "./locales/nb_NO/common.json"
import pl_PL from "./locales/pl_PL/common.json"
import ro_RO from "./locales/ro_RO/common.json"
import sk_SK from "./locales/sk_SK/common.json"
import sq_AL from "./locales/sq_AL/common.json"
import sv_SE from "./locales/sv_SE/common.json"
import zh_CN from "./locales/zh_CN/common.json"
import cs_CZ from "./locales/cs_CZ/common.json"
import en_US from "./locales/en_US/common.json"
import es_MX from "./locales/es_MX/common.json"
import fi_FI from "./locales/fi_FI/common.json"
import fr_FR from "./locales/fr_FR/common.json"
import hu_HU from "./locales/hu_HU/common.json"
import lt_LT from "./locales/lt_LT/common.json"
import mk_MK from "./locales/mk_MK/common.json"
import nl_NL from "./locales/nl_NL/common.json"
import pt_BR from "./locales/pt_BR/common.json"
import ru_RU from "./locales/ru_RU/common.json"
import sl_SI from "./locales/sl_SI/common.json"
import sr_RS from "./locales/sr_RS/common.json"
import tr_TR from "./locales/tr_TR/common.json"

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
export const resources = {
  bg_BG: { common: bg_BG },
  de_CH: { common: de_CH },
  es_ES: { common: es_ES },
  et_EE: { common: et_EE },
  fr_CA: { common: fr_CA },
  hr_HR: { common: hr_HR },
  it_IT: { common: it_IT },
  lv_LV: { common: lv_LV },
  nb_NO: { common: nb_NO },
  pl_PL: { common: pl_PL },
  ro_RO: { common: ro_RO },
  sk_SK: { common: sk_SK },
  sq_AL: { common: sq_AL },
  sv_SE: { common: sv_SE },
  zh_CN: { common: zh_CN },
  cs_CZ: { common: cs_CZ },
  en_US: { common: en_US },
  es_MX: { common: es_MX },
  fi_FI: { common: fi_FI },
  fr_FR: { common: fr_FR },
  hu_HU: { common: hu_HU },
  lt_LT: { common: lt_LT },
  mk_MK: { common: mk_MK },
  nl_NL: { common: nl_NL },
  pt_BR: { common: pt_BR },
  ru_RU: { common: ru_RU },
  sl_SI: { common: sl_SI },
  sr_RS: { common: sr_RS },
  tr_TR: { common: tr_TR },
} as const

export const defaultNS = "common"

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    defaultNS,
    fallbackLng: "en_US", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
